import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersPowerSelect from '../customers/customers-power-select.jsx';
import RecentJobsPowerSelect from './recent-jobs-power-select.jsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-power-select/dist/react-power-select.css';
import { Animate } from 'react-simple-animate';
import CurrencyInput from 'react-currency-input';

export default class QuickNewJob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      selectedCustomerId: 1532,
      selectedCustomer: null,
      selectedJobId: null,
      selectedJob: null,
      showAutofill: false,
      job_admin_fee_in_pence: 0,
      job_admin_fee_in_pence_formatted: '',
      job_customer_provided_fuel_cost_in_pence: 0,
      job_customer_provided_mileage: 0,
      job_customer_provided_job_price_in_pence: 0,
      play: false,
      customers:[],
      isCustomerRequestDateNeedToShow:false
    };
    this.onAddNewJobCreate = this.onAddNewJobCreate.
      bind(this);
    this.handleCustomerSelection = this.handleCustomerSelection.
      bind(this);
    this.handleJobSelection = this.handleJobSelection.
      bind(this);
    this.handlePickupDateCalendarChange = this.handlePickupDateCalendarChange.
      bind(this);
    this.handleVehicleRegistrationNumber = this.handleVehicleRegistrationNumber.
      bind(this);
    this.handleAllowBtnClickEvent = this.handleAllowBtnClickEvent.
      bind(this);
    this.handleDisallowowBtnClickEvent = this.handleDisallowowBtnClickEvent.
      bind(this);
    this.handleDropoffDateCalendarChange = this.handleDropoffDateCalendarChange.
      bind(this);
    this.handleAutofillButtonClick = this.handleAutofillButtonClick.
      bind(this);
  }
  componentDidMount() {
    this.setState({
      play: true
    });
    this.getCustomersForDropdownMenu();
    let companyId = $('#data-compnay-id').attr('data-compnay-id');
    if(companyId == "1"){
      this.setState({
        selectedCustomerId: 1532
      });
    }else if(companyId == "2"){
      this.setState({
        selectedCustomerId: 1533
      });
    }else if(companyId == "3"){
      this.setState({
        selectedCustomerId: 1536
      });
    }else if(companyId == "4"){
      this.setState({
        selectedCustomerId: 1535
      });
    }else if(companyId == "5"){
      this.setState({
        selectedCustomerId: 1537
      });
    }
    
  }
  getCustomersForDropdownMenu() {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/customers/all/for-dropdown-menu",
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(customersJson) {
      that.setState({
        customers: customersJson
      });
    });
  }
  handleVehicleRegistrationNumber(event){
        var  VehicleRegistrationNumber = event.target.value;
        return fetch(
            '/api/v1/portal/add-new-job/validation/vehicle/'+VehicleRegistrationNumber,
            {
              method: "GET",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "Authorization": 'Bearer ' + window.api_token,
                "Accept": 'application/json'
              }
            }
          ).then((responseText) => {
                let infoModal = $('#infomodal');
                let response = responseText.json();
                let modalFooter = "";
                let msg = "";
                if(responseText.status === 302){
                    response.then((resJson) => {
                        if(resJson.jobs[0]){
                            msg = "This number plate is already in the system under job number <a target='_blank' href='jobs/view/"+resJson.jobs[0].id+"'>"+resJson.jobs[0].id+"</a>, Are you sure you wish to continue?";
                        }else{
                            msg = "This number plate is already on the system - do you wish to continue?";
                        }
                        document.querySelector('#infomodallabel').innerHTML = 'Already exists';
                        document.querySelector('#infomodal .modal-body').innerHTML = msg;
                        modalFooter += '<button type="button" class="btn btn-danger allow-number-plate" id="allow-number-plate" data-dismiss="modal">Yes</button>';
                        modalFooter += '<button type="button" class="btn btn-primary disallow-number-plate" data-dismiss="modal" id="disallow-number-plate">No</button>';
                        document.querySelector('#infomodal .modal-footer').innerHTML = modalFooter;
                        document.getElementById("allow-number-plate").addEventListener("click", this.handleAllowBtnClickEvent);
                        document.getElementById("disallow-number-plate").addEventListener("click", this.handleDisallowowBtnClickEvent);
                        infoModal.modal();
                    });
                }else if(responseText.status === 400){
                    response.then((resJson) => {
                        document.querySelector('#infomodallabel').innerHTML = 'Error';
                        document.querySelector('#infomodal .modal-body').innerHTML = resJson.message;
                        infoModal.modal();
                    });
                }
                
          });
       
  }
  handleAllowBtnClickEvent(e){
    e.preventDefault();
    window.setTimeout(function () { 
        //document.getElementById('vehicle_vin_number').focus(); 
    }, 0); 
  }
  handleIsCustomerRequestDateNeedToShow(buttonVal){
    this.setState({
      isCustomerRequestDateNeedToShow: !this.state.isCustomerRequestDateNeedToShow,
      selectedPreposition:buttonVal
    });
  }
  handleDisallowowBtnClickEvent(e){
    e.preventDefault();
    window.setTimeout(function () { 
        document.getElementById('vehicle_registration_number').focus(); 
    }, 0); 
  }
  handleCustomerSelection(option) {
    if (option) {
      //document.querySelector('[name=special_instructions]').value = option.customer_special_instruction;
      this.setState({
        selectedCustomer: option,
        selectedCustomerId: option.id
      });
    }
  }

  handleJobSelection(option) {
    if (!(option && option.id)) {
      return false;
    }
    this.setState({
      selectedJobId: option.id,
      selectedJob: option,
      selectedCustomerId: option.customer.id,
    });
    // document.querySelector(
    //   '[name=customer_order_number]'
    // ).value = option.customer_order_number;
    // document.querySelector(
    //   '[name=customer_job_number]'
    // ).value = option.customer_job_number;
    document.querySelector(
      '[name=pickup_address_postcode]'
    ).value = option.pickup_address.postcode;
    document.querySelector(
      '[name=pickup_address_house_number_or_name]'
    ).value = option.pickup_address.house_number_or_name;
    document.querySelector(
      '[name=pickup_address_address_line_1]'
    ).value = option.pickup_address.address_line_1;
    document.querySelector(
      '[name=pickup_address_address_line_2]'
    ).value = option.pickup_address.address_line_2;
    document.querySelector(
      '[name=pickup_address_address_line_3]'
    ).value = option.pickup_address.address_line_3;
    document.querySelector(
      '[name=pickup_address_town_city]'
    ).value = option.pickup_address.town_city;
    document.querySelector(
      '[name=pickup_address_county_area]'
    ).value = option.pickup_address.county_area;
    document.querySelector(
      '[name=pickup_address_country]'
    ).value = option.pickup_address.country;
    document.querySelector(
      '[name=dropoff_address_postcode]'
    ).value = option.dropoff_address.postcode;
    document.querySelector(
      '[name=dropoff_address_house_number_or_name]'
    ).value = option.dropoff_address.house_number_or_name;
    document.querySelector(
      '[name=dropoff_address_address_line_1]'
    ).value = option.dropoff_address.address_line_1;
    document.querySelector(
      '[name=dropoff_address_address_line_2]'
    ).value = option.dropoff_address.address_line_2;
    document.querySelector(
      '[name=dropoff_address_address_line_3]'
    ).value = option.dropoff_address.address_line_3;
    document.querySelector(
      '[name=dropoff_address_town_city]'
    ).value = option.dropoff_address.town_city;
    document.querySelector(
      '[name=dropoff_address_county_area]'
    ).value = option.dropoff_address.county_area;
    document.querySelector(
      '[name=dropoff_address_country]'
    ).value = option.dropoff_address.country;
    // document.querySelector(
    //   '[name=pickup_preposition]'
    // ).value = option.pickup_preposition;
    document.querySelector(
      '[name=pickup_day]'
    ).value = option.pickup_day;
    document.querySelector(
      '[name=pickup_month]'
    ).value = option.pickup_month;
    document.querySelector(
      '[name=pickup_year]'
    ).value = option.pickup_year;
    document.querySelector(
      '[name=pickup_time]'
    ).value = option.pickup_time;
    document.querySelector(
      '[name=dropoff_preposition]'
    ).value = option.dropoff_preposition;
    document.querySelector(
      '[name=dropoff_day]'
    ).value = option.dropoff_day;
    document.querySelector(
      '[name=dropoff_month]'
    ).value = option.dropoff_month;
    document.querySelector(
      '[name=dropoff_year]'
    ).value = option.dropoff_year;
    document.querySelector(
      '[name=dropoff_time]'
    ).value = option.dropoff_time;
    // document.querySelector(
    //   '[name=vehicle_type]'
    // ).value = option.vehicle.type;
    // document.querySelector(
    //   '[name=vehicle_make]'
    // ).value = option.vehicle.make;
    // document.querySelector(
    //   '[name=vehicle_colour]'
    // ).value = option.vehicle.colour;
    // document.querySelector(
    //   '[name=vehicle_model]'
    // ).value = option.vehicle.model;
    document.querySelector(
      '[name=vehicle_registration_number]'
    ).value = option.vehicle.registration_number;
    // document.querySelector(
    //   '[name=vehicle_vin_number]'
    // ).value = option.vehicle.vin_number;
    // document.querySelector(
    //   '[name=vehicle_sliding_door]'
    // ).value = option.vehicle.sliding_door;
    document.querySelector(
      '[name=special_instructions]'
    ).value = option.special_instructions;
    document.querySelector(
      '[name=notes]'
    ).value = option.notes;

    if (option.fleet_paperwork_required) {
      document.querySelector(
        '#yes-fleet-paperwork').
        classList.add('active');
      document.querySelector(
        '#yes-fleet-paperwork input'
      ).checked = 'checked';
      document.querySelector(
      '#yes-fleet-paperwork input'
      ).classList.add('active');
    }
    else {
      document.querySelector(
        '#no-fleet-paperwork'
      ).classList.remove('active');
      document.querySelector(
        '#no-fleet-paperwork input'
      ).checked = 'checked';
      document.querySelector(
        '#yes-fleet-paperwork input'
      ).classList.remove('active');
    }

    if (option.jet_wash_required) {
      document.querySelector(
        '#yes-jet-wash'
      ).classList.add('active');
      document.querySelector(
        '#yes-jet-wash input'
      ).checked = 'checked';
    }
    else {
      document.querySelector(
        '#no-jet-wash'
      ).classList.remove('active');
      document.querySelector(
        '#no-jet-wash input'
      ).checked = 'checked';
    }

    if (option.fuel_included_in_job_price) {
      document.querySelector(
        '#yes-driver-fuel-expense-included-in-job-price'
      ).classList.add('active');
      document.querySelector(
        '#yes-driver-fuel-expense-included-in-job-price input'
      ).checked = 'checked';
    }
    else {
      document.querySelector(
        '#no-driver-fuel-expense-included-in-job-price'
      ).classList.remove('active');
      document.querySelector(
        '#no-driver-fuel-expense-included-in-job-price input'
      ).checked = 'checked';
    }
    if (option.type_of_movement) {
      document.querySelector(
        '#used-type-of-movement'
      ).classList.add('active');
      document.querySelector(
        '#used-type-of-movement input'
      ).checked = 'checked';
    }
    else {
      document.querySelector(
        '#new-type-of-movement'
      ).classList.remove('active');
      document.querySelector(
        '#new-type-of-movement input'
      ).checked = 'checked';
    }
  }

  onAddNewJobCreate(e) {
    e.preventDefault();

    $('#infomodallabel').html('Processing...');
    $('#infomodal .modal-body').html(
      'Adding new job to system...'
    );
    $('#infomodal').modal();

    let newJobData = {
      api_token: window.api_token,
      customer_id: this.state.selectedCustomerId,
      is_customer_request_date_needtoshow:this.state.isCustomerRequestDateNeedToShow,
      selected_preposition:this.state.selectedPreposition,
      // customer_order_number: document.querySelector(
      //   '[name=customer_order_number]').value,
      // customer_job_number: document.querySelector(
      //   '[name=customer_job_number]').value,
      job_admin_fee_in_pence: this.state.
        job_admin_fee_in_pence,
      job_customer_provided_fuel_cost_in_pence: this.state.
        job_customer_provided_fuel_cost_in_pence,
      job_customer_provided_mileage: this.state.
        job_customer_provided_mileage,
      job_customer_provided_job_price_in_pence: this.state.
        job_customer_provided_job_price_in_pence,

      // pickup_address: {
      //   postcode: document.querySelector(
      //     '[name=pickup_address_postcode]'
      //   ).value,
      //   house_number_or_name: document.querySelector(
      //     '[name=pickup_address_house_number_or_name]'
      //   ).value,
      //   address_line_1: document.querySelector(
      //     '[name=pickup_address_address_line_1]'
      //   ).value,
      //   address_line_2: document.querySelector(
      //     '[name=pickup_address_address_line_2]'
      //   ).value,
      //   address_line_3: document.querySelector(
      //     '[name=pickup_address_address_line_3]'
      //   ).value,
      //   town_city: document.querySelector(
      //     '[name=pickup_address_town_city]'
      //   ).value,
      //   county_area: document.querySelector(
      //     '[name=pickup_address_county_area]'
      //   ).value,
      //   country: document.querySelector(
      //     '[name=pickup_address_country]'
      //   ).value,
      //   opening_times: document.querySelector(
      //     '[name=pickup_address_opening_times]'
      //   ).value,
      //   compound_opening_times: document.querySelector(
      //     '[name=pickup_address_compound_opening_times]'
      //   ).value,
      //   contact_name: document.querySelector(
      //     '[name=pickup_address_contact_name]'
      //   ).value,
      //   contact_telephone_number: document.querySelector(
      //     '[name=pickup_address_contact_telephone_number]'
      //   ).value,
      // },

      // dropoff_address: {
      //   postcode: document.querySelector(
      //     '[name=dropoff_address_postcode]'
      //   ).value,
      //   house_number_or_name: document.querySelector(
      //     '[name=dropoff_address_house_number_or_name]'
      //   ).value,
      //   address_line_1: document.querySelector(
      //     '[name=dropoff_address_address_line_1]'
      //   ).value,
      //   address_line_2: document.querySelector(
      //     '[name=dropoff_address_address_line_2]'
      //   ).value,
      //   address_line_3: document.querySelector(
      //     '[name=dropoff_address_address_line_3]'
      //   ).value,
      //   town_city: document.querySelector(
      //     '[name=dropoff_address_town_city]'
      //   ).value,
      //   county_area: document.querySelector(
      //     '[name=dropoff_address_county_area]'
      //   ).value,
      //   country: document.querySelector(
      //     '[name=dropoff_address_country]'
      //   ).value,
      //   opening_times: document.querySelector(
      //     '[name=dropoff_address_opening_times]'
      //   ).value,
      //   compound_opening_times: document.querySelector(
      //     '[name=dropoff_address_compound_opening_times]'
      //   ).value,
      //   contact_name: document.querySelector(
      //     '[name=dropoff_address_contact_name]'
      //   ).value,
      //   contact_telephone_number: document.querySelector(
      //     '[name=dropoff_address_contact_telephone_number]'
      //   ).value,
      // },

      pickup_preposition: (document.querySelector(
        '[name=pickup_preposition]'
      )) ? document.querySelector(
        '[name=pickup_preposition]'
      ).value : '?',
      pickup_day: (document.querySelector(
        '[name=pickup_day]'
      )) ? document.querySelector(
        '[name=pickup_day]'
      ).value : '?',
      pickup_month: (document.querySelector(
        '[name=pickup_month]'
      )) ? document.querySelector(
        '[name=pickup_month]'
      ).value : '?',
      pickup_year: (document.querySelector(
        '[name=pickup_year]'
      )) ? document.querySelector(
        '[name=pickup_year]'
      ).value : '?',
      pickup_time: (document.querySelector(
        '[name=pickup_time]'
      )) ? document.querySelector(
        '[name=pickup_time]'
      ).value : '?',
      dropoff_preposition: (document.querySelector(
        '[name=dropoff_preposition]'
      )) ? document.querySelector(
        '[name=dropoff_preposition]'
      ).value : '?',
      dropoff_day: (document.querySelector(
        '[name=dropoff_day]'
      )) ? document.querySelector(
        '[name=dropoff_day]'
      ).value : '?',
      dropoff_month: (document.querySelector(
        '[name=dropoff_month]'
      )) ? document.querySelector(
        '[name=dropoff_month]'
      ).value : '?',
      dropoff_year: (document.querySelector(
        '[name=dropoff_year]'
      )) ? document.querySelector(
        '[name=dropoff_year]'
      ).value : '?',
      dropoff_time: (document.querySelector(
        '[name=dropoff_time]'
      )) ? document.querySelector(
        '[name=dropoff_time]'
      ).value : '?',
      // fleet_paperwork_required: document.querySelector(
      //   '#fleet-paperwork-form-radio-container label.active '+
      //   '[name=vehicle_fleet_paperwork_required]'
      // ).value,
      // jet_wash_required: document.querySelector(
      //   '#jet-wash-form-radio-container label.active '+
      //   '[name=vehicle_jet_wash_required]'
      // ).value,
      // fuel_included_in_job_price: document.querySelector(
      //   '#fuel-included-in-job-price-form-radio-container '+
      //   'label.active [name=driver_fuel_expense_included_in_job_price]'
      // ).value,
      // type_of_movement: (document.querySelector(
      //   '#type-of-movement-form-radio-container '+
      //   'label.active [name=type_of_movement]'
      // )) ? document.querySelector(
      //   '#type-of-movement-form-radio-container '+
      //   'label.active [name=type_of_movement]'
      // ).value : '',
      // customer_provided_fuel_cost: document.querySelector(
      //   '[name=customer_provided_fuel_cost]') ?
      //   document.querySelector(
      //   '[name=customer_provided_fuel_cost]'
      //   ).value : '',
      // customer_provided_mileage: document.querySelector(
      //   '[name=customer_provided_mileage]') ?
      //   document.querySelector(
      //     '[name=customer_provided_mileage]'
      //   ).value : '',
      // customer_provided_job_price: document.querySelector(
      //   '[name=customer_provided_job_price]') ?
      //   document.querySelector(
      //   '[name=customer_provided_job_price]'
      //   ).value : '',
      vehicle: {
        type: (document.querySelector(
          '[name=vehicle_type]')) ? 
          document.querySelector(
            '[name=vehicle_type]').value : '',
        make: (document.querySelector(
          '[name=vehicle_make]')) ? 
          document.querySelector(
            '[name=vehicle_make]').value : '',
        colour: (document.querySelector(
          '[name=vehicle_colour]')) ? 
          document.querySelector(
            '[name=vehicle_colour]').value : '',
        model: (document.querySelector(
          '[name=vehicle_model]')) ? 
          document.querySelector(
            '[name=vehicle_model]').value : '',
        registration_number: document.querySelector(
          '[name=vehicle_registration_number]').value,
        vin_number: (document.querySelector(
          '[name=vehicle_vin_number]')) ?
          document.querySelector(
            '[name=vehicle_vin_number]').value :'',
        sliding_door: (document.querySelector(
          '[name=vehicle_sliding_door]')) ? 
          document.querySelector(
            '[name=vehicle_sliding_door]').value : '',
      },
      quick_job_from:(document.querySelector(
        '[name=quick_job_from]')) ? 
        document.querySelector(
          '[name=quick_job_from]').value : '',
      quick_job_to:(document.querySelector(
        '[name=quick_job_to]')) ? 
        document.querySelector(
          '[name=quick_job_to]').value : '',
      // special_instructions: document.querySelector(
      //   '[name=special_instructions]').value,
      // notes: document.querySelector(
      //   '[name=notes]').value,
      selected_company:$('#navbarCurrentUserDropdown #data-compnay-id').attr('data-compnay-id')
    };
   
    $.ajax({
      type: "POST",
      url: '/api/v1/portal/jobs/quick-new-job',
      data: newJobData,
      dataType: "text/json",
      complete: function(response) {
        let infoModal = $('#infomodal');
        if (response.status === 200) {
          $('#infomodallabel').html('New job added successfully');
          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.replace(/\"/g,
              ""))
          );
          infoModal.modal();
          infoModal.on('hidden.bs.modal', function() {
            $('form input').val('').removeClass('active');
            $('form select').val('');
            $('form textarea').val('');
            $('form label').removeClass('active');
          });
        }
        else {
          $('#infomodallabel').html('Error adding new job');
          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.replace(/\"/g,
              ""))
          );
          infoModal.modal();
        }
      }
    });
  }

  handleDropoffDateCalendarChange(date) {
    document.querySelector(
      'select[name=dropoff_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      'select[name=dropoff_month]'
    ).value = ("0" + (date.getMonth()+1)).slice(-2);
    document.querySelector(
      'select[name=dropoff_year]'
    ).value = date.getFullYear();
    this.setState({
      dropoff_date: date
    });
  }
  handlePickupDateCalendarChange(date) {
    document.querySelector(
      'select[name=pickup_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      'select[name=pickup_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      'select[name=pickup_year]'
    ).value = date.getFullYear();
    this.setState({pickup_date: date});
  }

  handleAutofillButtonClick(e) {
    e.preventDefault();
    this.setState({
      showAutofill: !this.state.showAutofill
    });
  }

  render() {
    let Customers = [];
    if (this.state.customers.length > 0) {
      this.state.customers.forEach(function (i) {
        Customers.push(
          <option
            key={'customer-'+i.id}
            value={i.id}>
            {i.name}
          </option>);
      });
    }
    let customerId = this.state.selectedCustomerId;
    return (
      <Animate
        play={this.state.play}
        start={{opacity: 0}}
        end={{opacity: 1}}
      >
      <form id="add_new_job_form" ref="addNewJobForm">
        <fieldset>
          {/* <div className="row">
            <div className="col-md-12">
              <button
                onClick={(e) => {this.handleAutofillButtonClick(e)}}
                className="btn btn-lg btn-primary">
                <i className="fa fa-clone">
                </i>&nbsp;
                Autofill from existing job
              </button>
              {(this.state.showAutofill) ?
                <RecentJobsPowerSelect
                handleJobSelection={this.handleJobSelection} />
                : null
              }
            </div>
          </div><br /><br /> */}
          <div id="place-service-helper-div"></div>
          <div className="row">
            <div className="col-md-4 col-sm-12">
              <h3>Customer</h3>
              {/* <select
                className="form-control form-control-lg"
                name="customer_id"
                value={this.state.selectedCustomerId}
                onChange={(e) => {
                  this.setState({
                    selectedCustomerId: e.target.value
                  });
                }}>
                {Customers}
              </select> */}
              <CustomersPowerSelect
                handleCustomerSelection={this.handleCustomerSelection}
                selectedCustomerId={customerId}
              />
            </div>
            <div className="col-md-4 col-sm-12">
              <h3>Vehicle Details</h3>
              <div className="col-for-number-plate-and-vin">
                <input type="text" className="form-control form-control-lg"
                  placeholder="Number Plate"
                  name="vehicle_registration_number"
                  id="vehicle_registration_number" onBlur={this.handleVehicleRegistrationNumber} />
                {/* <input type="text" className="form-control form-control-lg"
                  placeholder="VIN Number"
                  name="vehicle_vin_number" id="vehicle_vin_number" /> */}
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <h3>&nbsp;</h3>
              <button className="btn btn-warning btn-lg"
                      onClick={(e)=>this.handleIsCustomerRequestDateNeedToShow('on')}
                      type="button">&nbsp;&nbsp; ON &nbsp;&nbsp;</button>
              &nbsp; &nbsp; &nbsp;
              <button className="btn btn-success btn-lg"
                      onClick={(e)=>this.handleIsCustomerRequestDateNeedToShow('by')}
                      type="button">&nbsp;&nbsp; BY &nbsp;&nbsp;</button>
            </div>
            {/* <div className="col-md-2 col-sm-12">
              <label>
                Customer Order Number
              </label>
              <input type="text"
                     name="customer_order_number"
                     className="form-control form-control-lg"
                     placeholder=""/>
            </div> */}

              {/* <div className="col-md-2 col-sm-12">
                <label>
                  Customer Job Number
                </label>
                <input type="text"
                       name="customer_job_number"
                       className="form-control form-control-lg"
                       placeholder=""/>
              </div> */}
          </div>

          {/* <div className="row row-spacer-1">
            <div className="col-md-12">
              <h3>Job Financials</h3>
            </div>
          </div> */}

          {/* <div className="row row-for-job-financials">
            <div className="col-md-2">
              <div className="form-group">
                <label>
                  Admin Fee
                </label>
                <CurrencyInput
                  type="text"
                  name="funds"
                  value={this.state.job_admin_fee_in_pence/100}
                  prefix={'£'}
                  type='text'
                  allowNegative={true}
                  className="form-control form-control-lg form-control-currency"
                  onChangeEvent={
                    (event, maskedValue, floatValue) => {
                      this.setState({
                        job_admin_fee_in_pence: (floatValue*100),
                        job_admin_fee_in_pence_formatted: maskedValue,
                      });
                    }
                  }
                />
              </div>
            </div>

            <div className="col-md-2">
              <div className="form-group text-center">
                <label>
                  Driver Fuel Expense included in Job Price?
                </label>

                <div className="btn-group btn-group-toggle"
                     id="fuel-included-in-job-price-form-radio-container"
                     data-toggle="buttons">
                  <label className={"btn btn-secondary" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.
                      new_job_defaults_driver_fuel_expense_included_in_job_price === 1
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="yes-driver-fuel-expense-included-in-job-price">
                    <input className={"form-control form-control-lg" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.
                      new_job_defaults_driver_fuel_expense_included_in_job_price === 1
                    ?
                    ' active '
                      : ''
                  )
                  }
                  defaultChecked={(
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.
                      new_job_defaults_driver_fuel_expense_included_in_job_price === 1
                    ? true : false
                  )}
                  name="driver_fuel_expense_included_in_job_price"
                  type="radio"
                  value="1" /> YES
                  </label>

                  <label className={"btn btn-secondary" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.
                      new_job_defaults_driver_fuel_expense_included_in_job_price !== 1
                      ?
                      ' active '
                      : ''
                  )
                  }
                  defaultChecked={(
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.
                      new_job_defaults_driver_fuel_expense_included_in_job_price !== 1
                      ? true : false
                  )}
                         id="no-driver-fuel-expense-included-in-job-price">
                    <input className={"form-control form-control-lg" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.
                      new_job_defaults_driver_fuel_expense_included_in_job_price !== 1
                    ?
                    ' active '
                      : ''
                  )
                  }
                           name="driver_fuel_expense_included_in_job_price"
                           type="radio" value="0" /> NO
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group text-center type-of-movement-form-radio-block">
                <label>
                  Type Of Movement ?
                </label>

                <div className="btn-group btn-group-toggle"
                     id="type-of-movement-form-radio-container"
                     data-toggle="buttons">
                  <label className={"btn btn-secondary"} id="used-type-of-movement">
                        <input className={"form-control form-control-lg"}
                        defaultChecked={false}
                        name="type_of_movement"
                        type="radio"
                        value="used" /> USED
                    </label>

                  <label className={"btn btn-secondary"} id="new-type-of-movement">
                        <input className={"form-control form-control-lg"}
                           name="type_of_movement"
                           defaultChecked={false}
                           type="radio" value="new" /> NEW
                  </label>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="row">
            {
              (this.state.selectedCustomer &&
                this.state.selectedCustomer.new_job_defaults_customer_provides_fuel_cost === 1)
              ?
                <div className="col-md-2 col-sm-12">
                  <label>
                    Customer Provided Fuel Cost
                  </label>
                  <CurrencyInput
                    name="funds"
                    value={this.state.job_customer_provided_fuel_cost_in_pence/100}
                    prefix={'£'}
                    type='text'
                    allowNegative={true}
                    className="form-control form-control-lg form-control-currency"
                    onChangeEvent={
                      (event, maskedValue, floatValue) => {
                        this.setState({
                          job_customer_provided_fuel_cost_in_pence: (floatValue*100),
                          job_customer_provided_fuel_cost_in_pence_formatted: maskedValue,
                        });
                      }
                    }
                  />
                </div>
                :
                null
            }
            {
              (this.state.selectedCustomer &&
                this.state.selectedCustomer.new_job_defaults_customer_provides_mileage === 1)
                ?
                <div className="col-md-2 col-sm-12">
                  <label>
                    Customer Provided Mileage
                  </label>
                  <input type="text"
                         name="customer_provided_mileage"
                         className="form-control form-control-lg"
                         value={this.state.job_customer_provided_mileage}
                         onChange={(e) => {
                           this.setState({
                             job_customer_provided_mileage: e.target.value,
                           });
                         }
                         }
                         placeholder=""/>
                </div>
                :
                null
            }
            {
              (this.state.selectedCustomer &&
                this.state.selectedCustomer.new_job_defaults_customer_provides_job_price === 1)
                ?
                <div className="col-md-2 col-sm-12">
                  <label>
                    Customer Provided Job Price
                  </label>
                  <CurrencyInput
                    name="funds"
                    value={this.state.job_customer_provided_job_price_in_pence/100}
                    prefix={'£'}
                    type='text'
                    allowNegative={true}
                    className="form-control form-control-lg form-control-currency"
                    onChangeEvent={
                      (event, maskedValue, floatValue) => {
                        this.setState({
                          job_customer_provided_job_price_in_pence: (floatValue*100),
                          job_customer_provided_job_price_in_pence_formatted: maskedValue,
                        });
                      }
                    }
                  />
                </div>
                :
                null
            }

          </div> */}


          {/* <div className="row row-spacer-1">
            <div className="col-md-12">
              <h3>Appraisal Settings</h3>
            </div>
          </div> */}

          {/* <div className="row">
            <div className="col-md-2">
              Manual Appraisal is always required
            </div>
            <div className="col-md-2">
              <div className="form-group text-center">
                <label>
                  Fleet Paperwork required?
                </label>

                <div className="btn-group btn-group-toggle"
                     id="fleet-paperwork-form-radio-container"
                     data-toggle="buttons">
                  <label className={"btn btn-secondary" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.new_job_defaults_fleet_paperwork_required === 1
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="yes-fleet-paperwork">
                    <input className={"form-control form-control-lg" + (
                      this.state.selectedCustomer &&
                      this.state.selectedCustomer.new_job_defaults_fleet_paperwork_required === 1
                        ?
                        ' active '
                        : ''
                    )
                    }
                           defaultChecked={(
                             this.state.selectedCustomer &&
                             this.state.selectedCustomer.new_job_defaults_fleet_paperwork_required === 1
                               ? true : false
                           )}
                           name="vehicle_fleet_paperwork_required"
                           type="radio" value="1" /> YES
                  </label>
                  <label className={"btn btn-secondary" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.new_job_defaults_fleet_paperwork_required !== 1
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="no-fleet-paperwork">
                    <input className={"form-control form-control-lg" + (
                      this.state.selectedCustomer &&
                      this.state.selectedCustomer.new_job_defaults_fleet_paperwork_required !== 1
                        ?
                        ' active '
                        : ''
                    )
                    }
                           defaultChecked={(
                             this.state.selectedCustomer &&
                             this.state.selectedCustomer.new_job_defaults_fleet_paperwork_required !== 1
                               ? true : false
                           )}
                           name="vehicle_fleet_paperwork_required"
                           type="radio" value="0" /> NO
                  </label>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="form-group text-center">
                <label>
                  Jet Wash required?
                </label>

                <div className="btn-group btn-group-toggle"
                     id="jet-wash-form-radio-container"
                     data-toggle="buttons">
                  <label className={"btn btn-secondary" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.new_job_defaults_jet_wash_required === 1
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="yes-jet-wash">
                    <input className={"form-control form-control-lg" + (
                      this.state.selectedCustomer &&
                      this.state.selectedCustomer.new_job_defaults_jet_wash_required === 1
                        ?
                        ' active '
                        : ''
                    )
                    }
                           defaultChecked={(
                             this.state.selectedCustomer &&
                             this.state.selectedCustomer.new_job_defaults_jet_wash_required === 1
                               ? true : false
                           )}
                           name="vehicle_jet_wash_required"
                           type="radio" value="1" /> YES
                  </label>
                  <label className={"btn btn-secondary" + (
                    this.state.selectedCustomer &&
                    this.state.selectedCustomer.new_job_defaults_jet_wash_required !== 1
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="no-jet-wash">
                    <input className={"form-control form-control-lg" + (
                      this.state.selectedCustomer &&
                      this.state.selectedCustomer.new_job_defaults_jet_wash_required !== 1
                        ?
                        ' active '
                        : ''
                    )
                    }
                           defaultChecked={(
                             this.state.selectedCustomer &&
                             this.state.selectedCustomer.new_job_defaults_jet_wash_required !== 1
                               ? true : false
                           )}
                           name="vehicle_jet_wash_required"
                           type="radio"
                           value="0" /> NO
                  </label>
                </div>
              </div>
            </div>
          </div> */}


          {/* <div className="row row-spacer-1">
            <div className="col-md-12">
              <h3>Vehicle Details</h3>
            </div>
          </div> */}

          <div className="row row-for-vehicle-details">
            {/* <div className="col-md-2">
              <div className="form-group">
                <select className="form-control form-control-lg selectpicker"
                  name="vehicle_type" id="vehicle_type">
                  <option value="car" data-icon="fa fa-car">&nbsp;
                    Car
                  </option>
                  <option value="van" data-icon="fa fa-truck">&nbsp;
                    Van
                  </option>
                </select>
              </div>
            </div> */}

            {/* <div className="col-md-2 col-for-number-plate-and-vin">
              <input type="text" className="form-control form-control-lg"
                placeholder="Number Plate"
                name="vehicle_registration_number"
                id="vehicle_registration_number" onBlur={this.handleVehicleRegistrationNumber} />
              <input type="text" className="form-control form-control-lg"
                placeholder="VIN Number"
                name="vehicle_vin_number" id="vehicle_vin_number" /> 
            </div> */}

            {/* <div className="col-md-2">
              <div className="form-group">
                <input type="text" className="form-control form-control-lg"
                  placeholder="Make"
                  name="vehicle_make" id="vehicle_make" />
              </div>
            </div> */}

            {/* <div className="col-md-2">
              <div className="form-group">
                <input type="text" className="form-control form-control-lg"
                  placeholder="Model"
                  name="vehicle_model" id="vehicle_model" />
              </div>
            </div> */}

            {/* <div className="col-md-2">
              <div className="form-group">
                <input type="text" className="form-control form-control-lg"
                  placeholder="Colour"
                  name="vehicle_colour" id="vehicle_colour" />
              </div>
            </div> */}

            {/* <div className="col-md-2">

              <div className="form-group form-group-for-sliding-door">
                <label htmlFor="vehicle_sliding_door">
                  Vehicle Sliding Door:
                </label>
                <select className="form-control form-control-lg"
                  name="vehicle_sliding_door"
                  id="vehicle_sliding_door">
                  <option value="not_applicable">
                    N/A
                  </option>
                  <option value="driver_side">
                    Driver Side
                  </option>
                  <option value="passenger_side">
                    Passenger Side
                  </option>
                </select>
              </div>
            </div>
           */}
          </div>

          {(this.state.isCustomerRequestDateNeedToShow) ? 
           <div className="row row-spacer-1">
            <div className="col-md-6">
              <h3>Customer Required Pickup Time <DatePicker
                  customInput={<a className="btn btn-default"><i
                  className="far fa-calendar-alt"></i></a>}
                  selected={this.state.pickup_date}
                  onChange={this.handlePickupDateCalendarChange} /></h3>
              <div className="input-group">
                <select
                  name="pickup_preposition"
                  className="form-control timedropdown"
                  defaultValue={this.state.selectedPreposition}
                  id="pickup_preposition"
                  autoFocus
                >
                  <option value="?">?</option>
                  <option value="by">BY</option>
                  <option value="on">ON</option>
                  <option value="from">FROM</option>
                </select>
                &nbsp;:&nbsp;

                <select name="pickup_day"
                        className="form-control timedropdown"
                >
                  <option value="?">?</option>
                  <option value="01">01</option>
                  <option value="02">02</option>
                  <option value="03">03</option>
                  <option value="04">04</option>
                  <option value="05">05</option>
                  <option value="06">06</option>
                  <option value="07">07</option>
                  <option value="08">08</option>
                  <option value="09">09</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                  <option value="25">25</option>
                  <option value="26">26</option>
                  <option value="27">27</option>
                  <option value="28">28</option>
                  <option value="29">29</option>
                  <option value="30">30</option>
                  <option value="31">31</option>
                </select>
                &nbsp;/&nbsp;
                <select name="pickup_month"
                        className="form-control timedropdown"
                >
                  <option value="?">?</option>
                  <option value="01">01</option>
                  <option value="02">02</option>
                  <option value="03">03</option>
                  <option value="04">04</option>
                  <option value="05">05</option>
                  <option value="06">06</option>
                  <option value="07">07</option>
                  <option value="08">08</option>
                  <option value="09">09</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                </select>
                &nbsp;/&nbsp;

                <select name="pickup_year"
                        className="form-control timedropdown"
                >
                  <option value="?">?</option>
                  <option value="2019">2019</option>
                  <option value="2020">2020</option>
                  <option value="2021">2021</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
                &nbsp;@&nbsp;

                <select name="pickup_time"
                        className="form-control timedropdown"
                >
                  <option value="?">?</option>
                  <option value="anytime">ANYTIME (9am-5pm)</option>
                  <option value="asap">ASAP</option>
                  <option value="am">AM</option>
                  <option value="pm">PM</option>
                  <option value="0700">7 AM</option>
                  <option value="0730">7:30 AM</option>
                  <option value="0800">8 AM</option>
                  <option value="0830">8:30 AM</option>
                  <option value="0900">9 AM</option>
                  <option value="0930">9:30 AM</option>
                  <option value="1000">10 AM</option>
                  <option value="1030">10:30 AM</option>
                  <option value="1100">11 AM</option>
                  <option value="1130">11:30 AM</option>
                  <option value="1200">12 PM</option>
                  <option value="1230">12:30 PM</option>
                  <option value="1300">1 PM</option>
                  <option value="1330">1:30 PM</option>
                  <option value="1400">2 PM</option>
                  <option value="1430">2:30 PM</option>
                  <option value="1500">3 PM</option>
                  <option value="1530">3:30 PM</option>
                  <option value="1600">4 PM</option>
                  <option value="1630">4:30 PM</option>
                  <option value="1700">5 PM</option>
                  <option value="1730">5:30 PM</option>
                  <option value="1800">6 PM</option>
                  <option value="1830">6:30 PM</option>
                  <option value="1900">7 PM</option>
                  <option value="1930">7:30 PM</option>
                  <option value="2000">8 PM</option>
                  <option value="2030">8:30 PM</option>
                  <option value="2100">9 PM</option>
                  <option value="2130">9:30 PM</option>
                  <option value="2200">10 PM</option>
                  <option value="2230">10:30 PM</option>
                  <option value="2300">11 PM</option>
                  <option value="2330">11:30 PM</option>
                  <option value="0000">MIDNIGHT</option>
                  <option value="1230">12:30 AM</option>
                  <option value="0100">1 AM</option>
                  <option value="0130">1:30 AM</option>
                  <option value="0200">2 AM</option>
                  <option value="0230">2:30 AM</option>
                  <option value="0300">3 AM</option>
                  <option value="0330">3:30 AM</option>
                  <option value="0400">4 AM</option>
                  <option value="0430">4:30 AM</option>
                  <option value="0500">5 AM</option>
                  <option value="0530">5:30 AM</option>
                  <option value="0600">6 AM</option>
                  <option value="0630">6:30 AM</option>
                </select>
              </div>
            </div>


              <div className="col-md-6">
                <h3>Customer Required Dropoff Time <DatePicker
                    customInput={<a className="btn btn-default">
                                  <i className="far fa-calendar-alt"></i>
                                </a>}
                    selected={this.state.dropoff_date}
                    onChange={this.handleDropoffDateCalendarChange} /></h3>
                <div className="input-group">
                  <select name="dropoff_preposition"
                          className="form-control timedropdown"
                          defaultValue={this.state.selectedPreposition}
                          id="dropoff_preposition"
                  >
                    <option value="?">?</option>
                    <option value="by">BY</option>
                    <option value="on">ON</option>
                    <option value="from">FROM</option>
                  </select>
                  &nbsp;:&nbsp;

                  <select name="dropoff_day"
                          className="form-control timedropdown"
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_month"
                          className="form-control timedropdown"
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_year"
                          className="form-control timedropdown"
                  >
                    <option value="?">?</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </select>
                  &nbsp;@&nbsp;
                  <select name="dropoff_time"
                          className="form-control timedropdown"
                  >
                    <option value="?">?</option>
                    <option value="anytime">ANYTIME (9am-5pm)</option>
                    <option value="asap">ASAP</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                    <option value="0700">7 AM</option>
                    <option value="0730">7:30 AM</option>
                    <option value="0800">8 AM</option>
                    <option value="0830">8:30 AM</option>
                    <option value="0900">9 AM</option>
                    <option value="0930">9:30 AM</option>
                    <option value="1000">10 AM</option>
                    <option value="1030">10:30 AM</option>
                    <option value="1100">11 AM</option>
                    <option value="1130">11:30 AM</option>
                    <option value="1200">12 PM</option>
                    <option value="1230">12:30 PM</option>
                    <option value="1300">1 PM</option>
                    <option value="1330">1:30 PM</option>
                    <option value="1400">2 PM</option>
                    <option value="1430">2:30 PM</option>
                    <option value="1500">3 PM</option>
                    <option value="1530">3:30 PM</option>
                    <option value="1600">4 PM</option>
                    <option value="1630">4:30 PM</option>
                    <option value="1700">5 PM</option>
                    <option value="1730">5:30 PM</option>
                    <option value="1800">6 PM</option>
                    <option value="1830">6:30 PM</option>
                    <option value="1900">7 PM</option>
                    <option value="1930">7:30 PM</option>
                    <option value="2000">8 PM</option>
                    <option value="2030">8:30 PM</option>
                    <option value="2100">9 PM</option>
                    <option value="2130">9:30 PM</option>
                    <option value="2200">10 PM</option>
                    <option value="2230">10:30 PM</option>
                    <option value="2300">11 PM</option>
                    <option value="2330">11:30 PM</option>
                    <option value="0000">MIDNIGHT</option>
                    <option value="1230">12:30 AM</option>
                    <option value="0100">1 AM</option>
                    <option value="0130">1:30 AM</option>
                    <option value="0200">2 AM</option>
                    <option value="0230">2:30 AM</option>
                    <option value="0300">3 AM</option>
                    <option value="0330">3:30 AM</option>
                    <option value="0400">4 AM</option>
                    <option value="0430">4:30 AM</option>
                    <option value="0500">5 AM</option>
                    <option value="0530">5:30 AM</option>
                    <option value="0600">6 AM</option>
                    <option value="0630">6:30 AM</option>
                  </select>
                </div>
              </div>
            </div> 
            : ''}

            <div className="row row-spacer-1">
              <div className="col-md-4">
                <div className="col-md-8"><h3>From</h3></div>
              {/* <div className="form-group address-finder">
                <div id="pickup_address_postcode_lookup">
                </div>
              </div> */}
              <div className="form-group row">
                <div className="col-md-12">
                  <input type="text" name="quick_job_from"
                         id="quick_job_from"
                         placeholder="From.."
                         className="form-control form-control-lg"  />
                </div>
              </div>

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_address_line_1">
                    Address Line 1:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_address_line_1"
                    id="pickup_address_address_line_1"
                    className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_address_line_2">
                    Address Line 2:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_address_line_2"
                    id="pickup_address_address_line_2"
                    className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_address_line_3">
                    Address Line 3:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_address_line_3"
                    id="pickup_address_address_line_3"
                    className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="pickup_address_town_city">
                  Town/City:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="pickup_address_town_city"
                  id="pickup_address_town_city"
                  className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="pickup_address_county_area">
                  County/Area:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="pickup_address_county_area"
                  id="pickup_address_county_area"
                  className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="pickup_address_country">
                  Country:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="pickup_address_country"
                  id="pickup_address_country"
                  className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_postcode">
                    Postcode:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_postcode"
                    id="pickup_address_postcode"
                    className="form-control form-control-lg" />
                </div>
              </div> */}


                {/* <hr />

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_opening_times">
                    Opening/Closing Times:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_opening_times"
                         id="pickup_address_opening_times"
                         placeholder="e.g. 9am to 11am, 1pm to 5pm"
                         className="form-control form-control-lg" />
                </div>
              </div> */}

                {/* <div className="form-group row">
                  <div className="col-md-4">
                    <label htmlFor="pickup_address_compound_opening_times">
                      Compound Opening/Closing Times:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input type="text" name="pickup_address_compound_opening_times"
                           id="pickup_address_compound_opening_times"
                           placeholder="e.g. 9am to 11am, 1pm to 5pm"
                           className="form-control form-control-lg" />
                  </div>
                </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_contact_name">
                    Contact Name:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_contact_name"
                         id="pickup_address_contact_name"
                         className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label
                    htmlFor="pickup_address_contact_telephone_number">
                    Contact Telephone Number:
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    type="text"
                    name="pickup_address_contact_telephone_number"
                    id="pickup_address_contact_telephone_number"
                    className="form-control form-control-lg" />
                </div>
              </div> */}

            </div>

            <div className="col-md-4">
              <div className="col-md-8"><h3>To</h3></div>
              {/* <div className="form-group address-finder">
                  <div id="dropoff_address_postcode_lookup">
                  </div>
              </div> */}
              <div className="form-group row">
                  <div className="col-md-12">
                    <input type="text" name="quick_job_to"
                      id="quick_job_to"
                      placeholder="To.."
                      className="form-control form-control-lg" />
                  </div>
              </div>

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_address_line_1">
                  Address Line 1:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_address_line_1"
                  id="dropoff_address_address_line_1"
                  className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_address_line_2">
                  Address Line 2:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_address_line_2"
                  id="dropoff_address_address_line_2"
                  className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_address_line_3">
                  Address Line 3:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_address_line_3"
                  id="dropoff_address_address_line_3"
                  className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_town_city">
                    Town/City:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_town_city"
                    id="dropoff_address_town_city"
                    className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_county_area">
                    County/Area:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_county_area"
                    id="dropoff_address_county_area"
                    className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_country">
                  Country:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_country"
                  id="dropoff_address_country"
                  className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_postcode">
                  Postcode:
                </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_postcode"
                    id="dropoff_address_postcode"
                    className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <hr />

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_opening_times">
                    Opening/Closing Times:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_opening_times"
                         id="dropoff_address_opening_times"
                         placeholder="e.g. 9am to 11am, 1pm to 5pm"
                         className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_compound_opening_times">
                    Compound Opening/Closing Times:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_compound_opening_times"
                         id="dropoff_address_compound_opening_times"
                         placeholder="e.g. 9am to 11am, 1pm to 5pm"
                         className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_contact_name">
                    Contact Name:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_contact_name"
                         id="dropoff_address_contact_name"
                         className="form-control form-control-lg" />
                </div>
              </div> */}

              {/* <div className="form-group row">
                <div className="col-md-4">
                  <label
                    htmlFor="dropoff_address_contact_telephone_number">
                    Contact Telephone Number:
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    type="text"
                    name="dropoff_address_contact_telephone_number"
                    id="dropoff_address_contact_telephone_number"
                    className="form-control form-control-lg" />
                </div>
              </div> */}
            </div>
          </div>

          <div className="row row-spacer-1">
            {/* <div className="col-md-6">
              <h3>
                <label htmlFor="special_instructions">
                  Special Instructions
                </label>
              </h3>
              <textarea className="form-control form-control-lg text-center"
                        name="special_instructions"
                        id="special_instructions">
              </textarea>
            </div> */}

            {/* <div className="col-md-6">
              <h3>
                <label htmlFor="notes">Notes</label>
              </h3>
              <textarea className="form-control form-control-lg text-center"
                        name="notes" id="notes">
              </textarea>
            </div> */}
          </div>

          <div className="row text-center row-spacer-1">
            <div className="col-md-12">
              <button className="btn btn-lg btn-primary"
                      onClick={this.onAddNewJobCreate}
                      type="button">Quick Add New Job </button>
            </div>
          </div>
          <br /><br /><br /><br /><br />
        </fieldset>
      </form>
      </Animate>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-quick-new-job')) {
  ReactDOM.render(<QuickNewJob />,
    document.getElementById(
      'react-component-g4-logistics-portal-quick-new-job')
  );
}
